// import * as request from '@/router/request'
// import axios from 'axios'
import { axios } from '@/router/request'
//查询单箱货物详情
export function getPackageInfoByPackageId(params) {

    return axios({
        url: '/u058-business/mall/v1/good/invoice/package/getPackageInfoByPackageId',
        method: 'post',
        data: params

    })
}
// 查看整箱货物详情
export function getPackageInfoByInvoiceId(params) {

    return axios({
        url: '/u058-business/mall/v1/good/invoice/package/getPackageInfoByInvoiceId',
        method: 'post',
        data: params

    })
}

//获取物流数据  默认进入
export function getExpressInvoiceLogByOrderId(params) {

    return axios({
        url: '/u058-business/mall/v1/mallgoodorderinvoice/getExpressInvoiceLogByOrderId',
        method: 'post',
        data: params

    })
}

//获取物流数据  弹窗进入
export function getExpressInvoiceLogByTraceId(params) {

    return axios({
        url: '/u058-business/mall/v1/mallgoodorderinvoice/getExpressInvoiceLogByTraceId',
        method: 'post',
        data: params

    })
}


//////////////////
// WEBPACK FOOTER
// ./api/index.js
// module id = null
// module chunks = 